import { render } from "./ListOfFarms.vue?vue&type=template&id=13cc3975"
import script from "./ListOfFarms.vue?vue&type=script&lang=js"
export * from "./ListOfFarms.vue?vue&type=script&lang=js"

import "./ListOfFarms.vue?vue&type=style&index=0&id=13cc3975&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__